'use client';

import { createContext, useContext } from 'react';
import { IDictionariesState } from '@/creditflowresearch/application/Dictionaries/helpers';
import useDictionaries from '@/creditflowresearch/application/Dictionaries/useDictionaries';

type DictionariesContextType = ReturnType<typeof useDictionaries>;

export const DictionariesContext = createContext<DictionariesContextType | null>(
  null,
);

export const useDictionariesContext = () => {
  const context = useContext(DictionariesContext);
  if (!context) {
    throw new Error('useDictionariesContext must be used within the DictionariesContext');
  }
  return context;
};

interface IProps {
  dictionaries?: IDictionariesState,
  children: React.ReactNode,
}

const DictionariesContextProvider = ({ children, dictionaries }: IProps) => (
  <DictionariesContext.Provider value={ useDictionaries(dictionaries) }>
    { children }
  </DictionariesContext.Provider>
);

export default DictionariesContextProvider;
